module.exports = __webpack_public_path__ + "static/media/ringback_tone.b198f018.mp3";